<template>
  <div>
    <div class="container">
      <voucher-chart-tile :id="id" :form="form" />
    </div>

    <br>

    <div class="container">
      <div class="spaced-row">
        <h3>Forms</h3>
        <div class="grow"></div>
        <mad-button color="brown" size="sm" @click="addTypeform">
          <mad-icon mdi="plus" />Add typeform
        </mad-button>
      </div>
      <br>
      <mad-datatable :rows="rows" :columns="columns" :per-page="10">
        <template slot="typeform id" slot-scope="{row}">{{ row.typeform_id }}</template>
        <template slot="barcode" slot-scope="{row}">{{ row.barcode.split('/').pop() }}</template>
        <template slot="preview" slot-scope="{row}">
          <mad-button
            color="brown"
            size="sm"
            @click.stop="createCoupon(row.typeform_id)"
          >
            <mad-icon mdi="eye" />
            Preview Voucher
          </mad-button>
        </template>
      </mad-datatable>
    </div>

    <br>

    <mad-form v-if="form.id" @submit.prevent="submit">
      <div class="container">
        <div class="spaced-row">
          <h2>Voucher</h2>
          <div class="grow"></div>
          <mad-button color="brown" @click.prevent="deleteVoucher(id)">
            <mad-icon mdi="trash-can-outline" />Delete voucher
          </mad-button>
        </div>
        <voucher-form :form="form" />

        <br>

        <div class="spaced-row">
          <mad-button @click="clickCancel">
            <mad-icon mdi="arrow-left" />
          </mad-button>
          <div class="grow"></div>
          <mad-button color="brown" size="sm" @click="submit">
            <mad-icon mdi="check" />Save voucher
          </mad-button>
        </div>
      </div>
    </mad-form>
  </div>
</template>

<script>
import VoucherChartTile from '../vouchers-overview/VoucherChartTile'
import VoucherForm from '../VoucherForm.vue'

export default {
  components: {
    VoucherChartTile,
    VoucherForm,
  },
  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    showColorpicker: false,
    data: null,
    columns: [{ key: 'typeform id' }, { key: 'barcode' }, { key: 'preview' }],
    form: {
      id: '',
      name: '',
      logo: '',
      logo_placement: '',
      background_color: '',
      button_color: '',
      button_text_color: '',
      coffee_color: '',
      coffee_image: '',
      coupon_image: '',
      courtesy_color: '',
      courtesy_text: '',
      free_color: '',
      forms: [],
      amount_of_used_vouchers: '',
      amount_of_vouchers: '',
    },
  }),

  computed: {
    iframeSrc() {
      const baseUrl = process.env.VUE_APP_CLIENT_ENDPOINT + '/preview'
      const data = this.form
      const url =
        baseUrl +
        '?' +
        Object.entries(data)
          .map(keyVal => `${keyVal[0]}=${encodeURIComponent(keyVal[1])}`)
          .join('&')

      return url
    },
    rows() {
      return this.form.forms.map(form => ({
        ...form,
        click: e => this.goToForm(form),
      }))
    },
  },

  watch: {
    id(to, from) {
      // fetch new data if route changes
      this.fetchData()
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      const location = await this.$store.dispatch('getLocation', {
        id: this.id,
      })

      this.form = location
    },

    addTypeform() {
      this.$router.push(`/locations/${this.id}/new-form`)
    },

    async submit() {
      await this.$store.dispatch('updateLocation', this.form)
      this.$router.push('/locations')
    },

    async createCoupon(typeformId) {
      await this.$store.dispatch('createCoupon', {
        typeform_id: typeformId,
        email: this.$store.state.user.email,
      })
      this.$mad.message.success(
        `Preview voucher is send to: ${this.$store.state.user.email}`
      )
    },

    goToForm(form) {
      this.$router.push(`/forms/${form.id}`)
    },

    async deleteVoucher(id) {
      const confirmed = confirm(
        `Deleting location: ${this.form.name}, are you sure?`
      )
      if (!confirmed) return
      await this.$store.dispatch('deleteLocation', { id })
      this.$mad.message.success('Location deleted')
      this.$router.push('/locations')
    },

    clickCancel() {
      this.$router.push('/locations')
    },
  },
}
</script>

<style>
</style>
